// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36FTi","toggle":"styles_toggle__2HuYK","preview":"styles_preview__3bsed"};